<template>
<van-popup v-model="showPopup"
           :overlay="false"
           position="bottom"
           :style="{'max-width': webWidth + 'px'}">
  <div class="navigate-search">
    <div class="search-top">
      <div class="search-form">
        <div class="search-input">
          <img src="../../assets/search-small-sentosa.svg" v-if="siteId === '1'"/>
          <img src="../../assets/search-small.svg" v-else />
          <cube-input v-model="searchStr"
                      :placeholder="$t('common.search')"
                      class="search"
                      @focus="handleFocus" />
          <div class="input-btn" v-if="searchStr" @click="handleSearch">{{ showCancel ? $t('common.cancel') : $t('common.confirm') }}</div>
        </div>
        <div class="close-btn" @click="hide">
          <img src="../../assets/close.svg" />
        </div>
      </div>
      <div class="current-location" @click="handleSelectCurrent">
        <img src="../../assets/destination.svg" />
        <span>{{ $t('common.myLocation') }}</span>
      </div>
    </div>
    <div class="results" v-if="showSearchResults">
      <div class="noData" v-if="noData">
        <empty />
      </div>
      <div v-else>
        <v-result-list :list="results" @result="handleClickResult" />
      </div>
    </div>
    <div v-else>
      <div class="search-history" v-if="historyKeys.length > 0">
        <div class="search-title">
          <div class="title">{{ $t('common.searchHistory') }}</div>
          <div class="delete-icon" @click="handleDelete">
            <img src="../../assets/delete-sentosa.svg" v-if="siteId === '1'"/>
            <img src="../../assets/delete.svg" v-else />
          </div>
        </div>
        <div class="list-wrapper" :style="heightStyle">
          <div class="search-list" ref="list">
            <div class="keyword"
                v-for="item in historyKeys"
                :key="item"
                @click="handleHistory(item)">{{ item }}</div>
          </div>
          <div class="more-btn" @click="handleExpand" v-if="isMore">
            <div class="more-text">{{ expand ? $t('common.searchLess') : $t('common.searchMore') }}</div>
            <img :class="{'reverse': expand}" src="../../assets/map-down.svg" />
          </div>
        </div>
      </div>
      <div class="hot-search" v-if="hotSearch.length > 0" :style="historyKeys.length > 0 ? 'margin-top: 7px' : 'margin-top: 13px'">
        <div class="search-title">
          <div class="title">{{ $t('common.hotSearch') }}</div>
        </div>
        <div class="search-list">
          <div class="keyword"
               v-for="item in hotSearch"
               :key="item"
               @click="handleHistory(item)">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</van-popup>
</template>

<script>
import { Popup } from 'vant'
import 'vant/lib/popup/style'
import { GetDistance } from '@/utils/index'
import { searchPlace, getHotWords, postHistoryWord, deleteHistoryWords } from '@/fetch/api'
import empty from '@/components/empty'
import ResultList from './ResultList'

export default {
  data () {
    return {
      historyKeys: [],
      hotSearch: [],
      showCancel: false,
      showSearchResults: false,
      showSearch: false,
      searchStr: '',
      noData: false,
      activeNames: [],
      showPopup: false,
      results: [],
      type: '',
      isMore: false,
      expand: false,
      listHeight: 0
    }
  },
  props: {
    geoData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    inThere: {
      type: Boolean,
      default: false
    },
    header: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    heightStyle () {
      if (this.isMore) {
        return this.expand ? `height: ${this.listHeight + 23}px` : 'height: 152px'
      } else {
        return `height: ${this.listHeight}px`
      }
    },
    siteId () {
      return this.$store.state.siteId
    },
    webWidth () {
      return this.$store.state.webWidth
    }
  },
  components: {
    'van-popup': Popup,
    empty,
    'v-result-list': ResultList
  },
  methods: {
    show (type) {
      this.showPopup = true
      this.type = type
      this.getHistoryKeys()
    },
    hide () {
      this.showPopup = false
      this.showCancel = false
      this.showSearchResults = false
      this.showSearch = false
      this.searchStr = ''
      this.noData = false
      this.activeNames = []
      this.showPopup = false
    },
    handleDelete () {
      console.log('delete')
      this.$createDialog({
        type: 'confirm',
        content: this.$t('common.deleteMsg'),
        cancelBtn: {
          text: this.$t('common.deleteText'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        confirmBtn: {
          text: this.$t('common.deleteCancel'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          // 点击不舍得触发，其实是取消
        },
        onCancel: () => {
          // 点击删除触发，其实是确认删除
          deleteHistoryWords(this.header)
          this.historyKeys = []
        }
      }).show()
    },
    handleFocus () {
      if (!this.showSearchResults) {
        this.showCancel = false
        this.showSearch = true
        this.showSearchResults = false
      } else {
        this.showCancel = false
      }
    },
    handleBeforeSearch () {
      const params = this.searchStr.trim()
      if (!params) {
        this.toast = this.$createToast({
          txt: this.$t('common.searchValidText'),
          type: 'txt',
          time: 2000
        })
        this.toast.show()
      } else {
        this.toast = this.$createToast({
          time: 0,
          txt: this.$t('common.loadingMsg'),
          mask: true
        })
        this.toast.show()
        const query = {
          q: params
        }
        if (this.$route.query.language === 'zh') {
          query.locale = 'cn'
        } else {
          query.locale = 'en'
        }
        console.log('query', query)
        searchPlace(this.siteId, query, this.header).then(data => {
          let arr = this.historyKeys.slice(0)
          let index = arr.findIndex(item => item === params)
          if (index > -1) {
            arr.splice(index, 1) // 删除相同的字段
          }
          arr.unshift(params)
          if (arr.length > 20) { // 控制长度
            arr.splice(20, 1)
          }
          this.historyKeys = arr
          this.handleResults(data, this.geoData.lon, this.geoData.lat)
          this.toast.hide()
        })
      }
    },
    // 处理搜索结果
    handleResults (res, longitude, latitude) {
      this.results = res.places.map(item => {
        let distance = ''
        if (longitude) {
          distance = GetDistance(latitude, longitude, item.lat, item.lon)
        }
        item.distance = distance
        return item
      })
      this.noData = res.places.length === 0
      this.showSearchResults = true
      this.showCancel = true
    },
    handleHistory (q) {
      this.searchStr = q
      this.handleBeforeSearch()
    },
    handleSearch () {
      if (!this.showCancel) { // 确定
        this.handleBeforeSearch()
      } else {
        this.showSearch = false
        this.searchStr = ''
        this.noData = false
        this.showSearchResults = false
        this.$nextTick(() => {
          const height = this.$refs.list.clientHeight
          this.isMore = height > 135
          this.listHeight = height
        })
      }
    },
    // 获取本地缓存的历史搜索记录
    getHistoryKeys () {
      const params = this.$route.query.language === 'zh' ? { locale: 'cn' } : { locale: 'en' }
      getHotWords(this.header, params).then(res => {
        this.hotSearch = res.map_search.map(item => item.word)
        this.historyKeys = res.search_histories.map(item => item.word)
        this.$nextTick(() => {
          if (this.historyKeys.length > 0) {
            const height = this.$refs.list.clientHeight
            this.isMore = height > 135
            this.listHeight = height
          }
        })
      })
    },
    // 点击搜索结果
    handleClickResult (index) {
      this.$emit('selectPlace', {
        type: this.type,
        detail: this.results[index]
      })
      this.hide()
    },
    // 选择当前位置
    handleSelectCurrent () {
      if (this.type === 'start' && !this.inThere) {
        this.$emit('selectPlace', {
          type: this.type,
          detail: {
            lat: '',
            lon: '',
            name: ''
          }
        })
        this.hide()
      } else if (this.type === 'end' && !this.inThere) {
        let text = ''
        if (this.siteId === '245') {
          text = this.$t('navigate.notInRws')
        } else if (this.siteId === '129') {
          text = this.$t('navigate.notInSingapore')
        } else if (this.siteId === '33') {
          text = this.$t('navigate.notInGermany')
        }  else {
          text = this.$t('navigate.notInSentosa')
        }
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: text
        })
        this.toast.show()
      } else {
        this.$emit('selectPlace', {
          type: this.type,
          detail: {
            lat: this.geoData.lat,
            lon: this.geoData.lon,
            name: this.$t('common.myLocation')
          }
        })
        this.hide()
      }
    },
    // 展开历史
    handleExpand () {
      console.log('this.expand', this.expand)
      this.expand = !this.expand
    }
  }
}
</script>

<style lang="scss">
.navigate-search {
  height: 100%;
  padding: 109px 12px 0;
  overflow: auto;

  .search-top {
    position: fixed;
    top: 0;
    left: 12px;
    right: 12px;
    background-color: #ffffff;
  }

  .search-form {
    padding-top: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .search-input {
    background-color: #f3f3f3;
    flex: 1;
    border-radius: 16px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;

    img {
      width: 14px;
      display: block;
    }

    .search {
      flex: 1;
    }
  }

  .input-btn {
    padding: 0 19px 0 5px;
    font-size: 14px;
    line-height: 32px;
    height: 32px;
    color: #f8a909;
    font-weight: bold;
    font-family: "Montserrat";
  }

  .close-btn {
    padding-left: 13px;

    img {
      width: 18px;
      height: 18px;
      display: block;
    }
  }

  .search-title {
    position: relative;

    .title {
      font-size: 16px;
      line-height: 22px;
      font-weight: bold;
      font-family: "Montserrat";
      color: #000000;
    }

    .delete-icon {
      padding: 10px;
      position: absolute;
      top: 50%;
      right: -10px;
      transform: translateY(-50%);
      img {
        width: 13px;
        display: block;
      }
    }
  }

  .current-location {
    padding: 16px 12px 13px;
    border-bottom: 7px solid #f7f7f7;
    margin: 0 -12px;
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
      color: #222215;
      display: block;
      margin-left: 7px;
    }

    img {
      width: 32px;
      height: 32px;
      display: block;
    }
  }

  .search-history {
    margin-top: 13px;
  }

  .list-wrapper {
    overflow: hidden;
    position: relative;
    transition: height 0.3s ease-in-out;
  }

  .search-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
  }

  .more-list {
    display: flex;
    flex-wrap: wrap;
  }

  .more-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #222125;
    padding: 7px 0 4px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #ffffff;

    img {
      width: 10px;
      height: 5px;
      display: block;
      margin-left: 5px;

      &.reverse {
        transform: rotateZ(180deg);
      }
    }
  }

  .keyword {
    font-size: 12Px; // 首字母大写是为了被 px2rem忽略，勿改.
    line-height: 17Px;
    color: #222215;
    padding: 7Px 20Px;
    background-color: #f7f7f7;
    border-radius: 15Px;
    margin-right: 12Px;
    margin-bottom: 13Px;
    max-width: 135Px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .noData {
    font-size: 14px;
    color: #888888;
    margin: 0 -12px;
  }
}
</style>
